var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',{staticClass:"table-empty-state"},[_c('td',{attrs:{"colspan":_vm.table.cells.length}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }